module.exports = __webpack_public_path__ + "img/UpstreamNZ_Good_Cause.f56b9173.png";